//this will have the review
import { createContext } from 'react';

//this will have the company and the settings
export interface MaintenanceContext {
    maintenanceMode: boolean;
    setMaintenanceMode: React.Dispatch<React.SetStateAction<boolean>>;
    maintenanceMessage: string;
    setMaintenanceMessage: React.Dispatch<React.SetStateAction<string>>;
}

export const MaintenanceContext = createContext<MaintenanceContext>({
    maintenanceMode: false,
    setMaintenanceMode: () => { },
    maintenanceMessage: "",
    setMaintenanceMessage: () => { },
});

export const maintenanceExternal = {
    setMode: (_v: boolean) => { },
    setMessage: (_msg: string) => { },
};

